import React, { FunctionComponent, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from 'plume-ui';
import {
  OutreachConfigGenericFormField,
  OutreachConfigSections,
  OutreachTimeFormFields,
} from '../../../../../types';
import OutreachConfigSection from '../../../OutreachConfigSection';
import { Maybe } from '../../../../../../../types';
import useValidation from '../../../hooks/useValidation';
import useTimeFieldActions from '../../../hooks/useTimeFieldActions';
import { Permission } from '../../../../../../../userPermissionConfig';
import { useFeaturePermission } from '../../../../../../../hooks/useFeaturePermission';

export type FormikOutreachSubscriberTimeValue = {
  from: Maybe<Date> | null;
  to: Maybe<Date> | null;
};

const FormikOutreachSubscriberTimeField: FunctionComponent<OutreachConfigGenericFormField<
  FormikOutreachSubscriberTimeValue
>> = ({ field, form }) => {
  const { t } = useTranslation();
  const { isSectionComplete } = useValidation();
  const { hasPermission } = useFeaturePermission();
  const { renderDropdownFor } = useTimeFieldActions(field, form);
  const isComplete = isSectionComplete(
    OutreachConfigSections.SubscriberOutreachTime,
  );
  const canEditSubscriberPush = hasPermission(
    Permission.EditSubscriberPushOutreach,
  );

  const titleCopyId = 'outreach.form.subscriberOutreachTimeSection.title';
  const subtitleCopyId = 'outreach.form.subscriberOutreachTimeSection.subtitle';
  return (
    <OutreachConfigSection
      title={t(titleCopyId)}
      subtitle={t(subtitleCopyId)}
      isRequired
      isComplete={isComplete}
      isOpen={canEditSubscriberPush}
    >
      <div className="OutreachContainer__subscriber-outreach-time-row">
        {renderDropdownFor(OutreachTimeFormFields.From)}
        <Divider
          classes={(current) => ({
            ...current,
            root: `${current.root} OutreachContainer__subscriber-outreach-time-divider`,
          })}
        />
        {renderDropdownFor(OutreachTimeFormFields.To)}
      </div>
    </OutreachConfigSection>
  );
};

export default memo(FormikOutreachSubscriberTimeField);
